export default ({ request }) => ({
  fabricExpenseListApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/expense/list',
      method: 'post',
      data,
    })
  },
  fabricExpenseChooseFabricListApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/expense/choose/fabric/list',
      method: 'post',
      data,
    })
  },
  fabricExpenseSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/expense/save',
      method: 'post',
      data,
    })
  },
  fabricExpenseDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/expense/detail',
      method: 'post',
      data,
    })
  },
  fabricExpenseDelApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/expense/del',
      method: 'post',
      data,
    })
  },
  fabricExpenseSubmitOaApplyApi(data = {}) {
    return request({
      url: '/oa/fabric/expense/apply',
      method: 'post',
      data,
    })
  },
  fabricExpenseItemListApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/expense/item/list',
      method: 'post',
      data,
    })
  },
  fabricExpenseDocistApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/expense/doc/list',
      method: 'post',
      data,
    })
  },
})
